import { LayoutDashboard, MailPlus, ScrollText, Settings, UserPlus, Users } from "lucide-react";
import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";

const itens = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/convites", label: "Convites", icon: MailPlus },
  { to: "/solicitacoes", label: "Solicitações", icon: UserPlus },
  { to: "/usuarios", label: "Usuários", icon: Users },
  { to: "/audit-log", label: "Audit log", icon: ScrollText },
  { to: "/configuracoes", label: "Configurações", icon: Settings },
];

export function Sidebar() {
  return (
    <aside className="hidden w-60 shrink-0 border-r border-sidebar-border bg-sidebar text-sidebar-foreground md:flex md:flex-col">
      <div className="px-6 py-6">
        <p className="font-display text-lg font-semibold">Ela Analisa</p>
        <p className="text-xs uppercase tracking-wide text-muted-foreground">Painel admin</p>
      </div>
      <nav className="flex flex-1 flex-col gap-1 px-3 pb-6">
        {itens.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors",
                isActive
                  ? "bg-sidebar-accent text-sidebar-accent-foreground"
                  : "text-muted-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground",
              )
            }
          >
            <Icon className="size-4" />
            {label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
